import {
	Component,
	ChangeDetectionStrategy,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { Location } from '@angular/common';
import { Subject, timer, merge, of } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

@Component({
	selector: 'rpshared-save-bar',
	templateUrl: './save-bar.component.html',
	styleUrls: ['./save-bar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveBarComponent {
	private _invalidSubmission = new Subject<void>();
	@Input() title: string;
	@Input() isSaving = false;
	@Input() set isFormInvalid(_value: number) {
		this._invalidSubmission.next();
	}
	@Output() save = new EventEmitter<boolean>();

	readonly invalidSubmission$ = this._invalidSubmission.pipe(
		mapTo(true),
		switchMap((val) => merge(of(val), timer(1000).pipe(mapTo(false))))
	);

	constructor(private readonly location: Location) {}

	saveAndStay() {
		this.save.emit(true);
	}

	saveAndClose() {
		this.save.emit(false);
	}

	cancelAndClose() {
		this.location.back();
	}
}
